<template>
  <div>
    <div id="loading-wrapper">
      <div id="loading-text">
        <svg
          width="100"
          height="27"
          viewBox="0 0 100 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.2397 2.95491H11.2633V0H10.6119V2.95491H9.6355V11.3525H10.6119V14.3058H11.2633V11.3525H12.2397V2.95491Z"
            fill="#19D684"
          />
          <path
            d="M13.847 3.74597V10.0885C15.3752 11.0244 16.1944 12.7574 16.1944 14.883C16.1944 18.0457 14.3643 20.2861 10.9304 20.2861C7.52331 20.2861 5.69319 17.9531 5.69319 14.883C5.69319 12.5397 6.63655 10.7176 8.40221 9.86218V3.64655C3.40396 4.51392 0 8.10343 0 14.7905C0 22.2814 4.98252 26.0869 10.9241 26.0869C17.0041 26.0869 21.875 22.3723 21.875 14.883C21.875 8.65196 18.6456 4.82076 13.847 3.74597Z"
            fill="white"
          />
          <path
            d="M33.991 15.3486C33.991 14.2133 33.3243 12.9834 32.4837 12.9834C31.7596 12.9834 30.4548 13.6895 29.7004 14.3653V24.4023H23.9583V8.4979H29.7004V10.0691C30.6287 9.14834 32.2812 8.13467 33.9607 8.13467C37.6995 8.13467 39.5833 10.6823 39.5833 14.1829V24.404H33.991V15.3486Z"
            fill="white"
          />
          <path
            d="M52.17 24.6844H46.0342L46.0057 8.90059H39.323V3.08557H58.8542V8.90059H52.17V24.6844Z"
            fill="white"
          />
          <path
            d="M60.4167 8.62418H66.1459V24.6844H60.4167V8.62418ZM63.3221 6.54584C62.0171 6.54584 60.774 5.36846 60.774 3.69452C60.774 2.0513 61.9583 0.841492 63.3221 0.841492C64.6565 0.841492 65.9322 2.0513 65.9322 3.69452C65.9454 4.43401 65.6783 5.14891 65.1892 5.68313C64.7002 6.21735 64.029 6.52749 63.3221 6.54584Z"
            fill="white"
          />
          <path
            d="M77.2176 13.4934C74.5953 13.4934 73.7005 15.1146 73.7005 16.7056C73.7005 18.2039 74.9697 19.6113 77.1605 19.6113C78.8025 19.6113 79.84 18.9379 81.8294 17.714L83.3333 22.1804C81.6041 23.7107 79.1832 24.9649 76.4736 24.9649C71.3129 24.9649 67.9688 22.3033 67.9688 16.7359C67.9688 11.0456 71.8032 8.41592 76.6465 8.41592C78.9005 8.38659 81.0965 9.17406 82.8717 10.6483L81.8341 15.2375C80.3017 14.1971 79.1483 13.4934 77.2176 13.4934Z"
            fill="white"
          />
          <path
            d="M90.6766 18.7164V24.6845H85.1909L85.1562 1.12204H90.6766V12.4387L94.1947 8.69482H99.5152L99.7434 9.62228L94.9377 14.9743L100 23.6634L99.7418 24.6845H94.3364L90.6766 18.7164Z"
            fill="white"
          />
        </svg>
      </div>
      <div id="loading-content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading",
};
</script>

<style lang="scss">
@import "./loading.page.component.scss";
</style>
